import * as d3 from 'd3'
export function mobileCheck(){
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
}

export function getResume(){
  return [
  // {
  //     id: 1,
  //     job: "Israel Defense Forces, Naval Systems Operator",
  //     longTitle: "Israel Defense Forces — Naval Systems Operator",
  //     startDate: new Date(2000, 9,31),
  //     endDate: new Date(2003, 9, 29),
  //     type: "job",
  //     desc:[
  //     'Served as a combat trained fighter on a missile ship',
  //     'Operated and trained soldiers, officers and future commanders on using and understanding engines, water supply and emergency protocols'
  //     ]
  //   },
    // {
    //   id: 2,
    //   job: "Chayon LTD., Assistant Lab Manager, Israel",
    //   longTitle: "Chayon LTD. — Assistant Lab Manager",
    //   startDate: new Date(2003, 10, 1),
    //   endDate: new Date(2006, 6, 30),
    //   type: "job",
    //   desc:[
    //   'Diagnosed and fixed technical issues on computer hardware such as CPU, Motherboards, RAM, etc.',
    //   'Provided IT support for company employees, workstation installations, OS installations and hardware upgrades'
    //   ]
    // },

    {
      id: 3,
      job: 'M.S.K Cancer Center, Web Developer',
      longTitle: "Memorial Sloan Kettering Cancer Center — Web Developer",
      startDate: new Date(2014, 4, 1),
      endDate: new Date(2014, 11, 1),
      type: "job",
      desc:[
      'Designed and developed a web application for semi automatic statistical segmentation (SASS) to be used by medical physicists, radiology specialists and researchers to calculate the volumes of body organs and tumors',
      'Designed an interface to segment body structures while using multiple modalities (different protocols of MRI, CT, etc)',
      'Implemented machine-learning algorithm to segment the selected body organ or tumor',
      'Designed a database to store statistics collected from the above system'
      ]
    },
    {
      id: 4,
      job: "NOAA CREST, Data Wrangler and Viz. Developer",
      longTitle: "NOAA CREST — Data Wrangler and Visualization Developer",
      startDate: new Date(2015, 8, 1),
      endDate: new Date(2016, 6, 1),
      type: "job",
      desc:[
        "Simplifying large data sets in order to focus on the main area of interest",
        "Transforming data sets to different forms for data analysis",
        "Converting data to different formats according to the project needs",
        "Design and develop data visualization web applications",
        "Advising experts about tools to be used in projects according to their needs"
      ]
    },
    {
      id: 5,
      job:"Protégé, Data Viz. Engineer",
      longTitle: "Protégé Partners — Data Visualization Engineer",
      startDate: new Date(2016, 6, 1),
      endDate: new Date(2016, 7, 31),
      type: "job",
      desc:[
        "Led the complete lifecycle of visual analytics applications, from development of mock ups to the complete production-ready application",
        "Designed and developed rich interactive graphics and data visualizations web application, using D3, to drive key business decisions",
        "Wrote scripts using Python to aggregate data from several sources into a single data source"
        ]
    },
    // {
    //   id: 6,
    //   job: "Israel Ministry of Defense, IT Manager/ Security Supervisor, USA/ Austria",
    //   longTitle: "Israel Ministry of Defense — IT Manager/ Security Supervisor",
    //   startDate: new Date(2006, 8, 1),
    //   endDate: new Date(2015, 1, 1),
    //   type: "job",
    //   desc:[
    //     "Designed software using VBA to analyze employees’ performance by feeding it with the security statistics of each shift",
    //     "Designed and implemented software using VBA to manage and schedule overseas shifts for local employees. The software automatically retrieves the employees’ details from a database, assigns them to a hotel and sends an email notification to the relevant office",
    //     "Designed and developed software to analyze data about cargo which is being moved, so that management could obtain statistics that help them plan manpower",
    //     "Managed a team of 7 employees during flights to ensure security protocols are followed",
    //     "Manage maintenance and troubleshoot of devices such as CT machines, X-Ray machines and explosive detectors"
    //     ]
    // },
    {
      id: 7,
      job: "Bachelor Degree (CSc), City College of New York",
      longTitle: "Computer Science (B.Sc), City College of New York",
      startDate: new Date(2010, 7, 1),
      endDate: new Date(2014, 11, 20),
      type: "edu",
      desc:["Honors: Magna Cum Laude", "Senior Project: Initiating complex operations using mobile device voice recognition", "Awards: The Computer Science Outstanding Project Implementation Award"]
    },
    {
      id: 8,
      job: "Masters Degree (CSc), City College of New York",
      longTitle: "Computer Science (M.Sc), City College of New York",
      startDate: new Date(2015, 7, 1),
      endDate: new Date(2016, 11, 20),
      type: "edu",
      desc:[{courses:["Data Visualization" , "Big Data" , "Computer Security", "Artificial Intelligence", "Natural Language Processing"]}, "Master's Thesis: Semi-Supervised Clustering, K-Means and Kernel K-Means"]
    },
    {
      id: 9,
      job: "Royal Bank of Canada Capital Markets, Software Engineer",
      longTitle: "Royal Bank of Canada Capital Markets, Engineer",
      startDate: new Date(2017, 1, 21),
      endDate: new Date(2019, 9, 1),
      type: "job",
      desc: [
        "|||Enterprise Data Lake and Catalog",
        "Built the enterprise Data Lake and a metadata catalog using Django",
        "Developed a data science platform integrating Jupyter with Hadoop for executing Big Data and AI jobs"
      ]
    },
    {
      id: 10,
      job: "Royal Bank of Canada Capital Markets, Senior Full Stack Engineer",
      longTitle: "Royal Bank of Canada Capital Markets, Senior Full Stack Engineer",
      startDate: new Date(2019, 9, 1),
      endDate: new Date(2020, 12, 31),
      type: "job",
      desc: [
        "|||Data Exploration and Dashboarding Platform",
        "Led development of the enterprise data exploration and dashboarding platform, widely adopted for daily and periodic report for internal clients, regulators and senior management",
        "Implemented high-performance web-based data viewer which can handle millions of rows, supporting complex filters, aggregations and pivots within seconds"
      ]
    },
    {
      id: 11,
      job: "Royal Bank of Canada Capital Markets, Principal Software Engineer (Data & Analytics)",
      longTitle: "RBC Capital Markets, Principal Software Engineer",
      startDate: new Date(2021, 1, 1),
      endDate: new Date(2022, 1, 28),
      type: "job",
      desc: [
        "|||Risk Inventory System",
        "Led the design and implementation of a highly scalable risk system, reducing data ingestion from hours to minutes and query times from minutes to seconds",
        "Developed a DSL for dynamic data enrichment and a governance model for data modification requests",
        "Developed a daily workflow to compare 15 years of security prices, reducing data ingestion from hours to minutes while ensuring reliable re-runs for data accuracy",
        "|||Cash Management System",
        "Led the development of a fault-tolerant system with a real-time UI, managing thousands of accounts and transactions",
        "Provided mentorship on various computer science topics and new technologies"
      ]
    },
    {
      id: 12,
      job: "Royal Bank of Canada Capital Markets, Principal Software Engineer (Shared Tech. Services)",
      longTitle: "RBC Capital Markets, Principal Software Engineer",
      startDate: new Date(2022, 2, 1),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth()-1, new Date().getDate()),
      type: "job",
      desc: [
        "|||T+1 Settlement Cycle Platform",
        "Designed and implemented a resilient, distributed system and SDKs, to manage client interactions, data TTL, and de-duplication",
        "The platform enables clients to transmit and consume tens of thousands of messages per second with guaranteed delivery",
        "The platform delivered over 2B messages to date and was established as a critical dependency for downstream systems, report generation and insights.",
        "|||Cloud-Native Lambda Platform",
        "Developed a fault-tolerant, highly scalable lambda platform with real-time UI for logs, execution results, and debug information",
        "Client are able to interact with functions over HTTP or using WebSockets for real time pub/sub",
        "Designed functions to scale horizontally and vertically based on metrics such as request latency, resource utilization and call volume",
        "Integrated with OpenTelemetry for enhanced developer experience, monitoring and performance analysis",
        "Supports AI/ML use cases with the ability to execute long running processes as well as evaluate, generate and distribute Jupyter notebooks."
      ]
    }
  ]
}


export function wrap(text, width) {
  text.each(function() {
    var text = d3.select(this),
        x = d3.select(this).attr('x'),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
      }
    }
  });
}



export function getProjects(){
  return [
    {
      projectTitle: "D311",
      img: "./assets/img/d311.png",
      link: "http://lsxliron.github.io/d311",
      projectDescription: "An NYC interactive visualization where the areas most vulnerable to flooding are identified using flood-related NYC311 call records from January 2010 to November 2015",
      source: "",
      screenshots: false
    },
    {
      projectTitle: "Facebook Repositories Visualization",
      img: "./assets/img/oss-dataviz.png",
      link: "http://lsxliron.github.io/oss-dataviz",
      projectDescription: "Dynamic visualization of the growth of open-source Facebook projects on Github using D3. Utilizes a treemap of repositories, filters, charts and more.",
      source: "https://github.com/lsxliron/oss-dataviz",
      screenshots: false
    },
    {
      projectTitle: "Django Hackathon Starter Kit",
      img: "./assets/img/starter-kit.png",
      link: "",
      projectDescription: "A Django boilerplate containing over two dozen API examples and several OAuth integrations, along with an Ionic application for both mobile and web applications",
      source: "https://github.com/DrkSephy/django-hackathon-starter",
      screenshots: false
    },
    {
      projectTitle: "PySAASS",
      img: "./assets/img/pysaass.png",
      link: "",
      projectDescription: "A web application for semi automatic statistical segmentation (SASS) to be used by medical physicists, radiology specialists and researchers to detect and calculate the volumes of body organs and tumors",
      source: "",
      screenshots: true,
      carouselId: "pysaass-carousel"
    }
    // {
    //   projectTitle: "Fintech-Hackathon Starter Kit",
    //   img: "./assets/img/zahn-logo.jpg",
    //   link: "",
    //   projectDescription: "This is a description",
    //   source: "https://github.com/lsxliron/Zahn-Center-Hackathon-Starter-Kit",
    //   screenshots:[]
    // },
    // {
    //   projectTitle: "Semi Supervised K-Means Clustering",
    //   img: "./assets/img/clustering.png",
    //   link: "",
    //   projectDescription: "A semi supervised algorithm for K Means and Kernel K Means clustering that I built as a part of my Thesis",
    //   source: "https://github.com/lsxliron/SemiSupervisedKMeans",
    //   screenshots:[]
    // },
  ]
}

export function getTutorials(){
  return [
  {
      projectTitle: "Simple Scatter-plot Using NVD3",
      img: "./assets/img/nvd3.png",
      link: "http://lsxliron.github.io/nvd3Tutorial/",
      projectDescription: "A short tutorial that shows how to build and interactive scatter plot using the NVD3 library",
      source: "https://github.com/lsxliron/nvd3Tutorial",
      screenshots:false
    },
    {
      projectTitle: "Storing, and Loading Dicom Files",
      img: "./assets/img/blogger.png",
      link: "http://lsxliron.blogspot.com/",
      projectDescription: "How to efficiently store medical imaging pixel data for fast access and manipulation",
      source: "",
      screenshots:false
    }
  ]
}

export function getExperience(){
  return [
    // {lang: "Python", years: 5},
    {lang: "Python", years: 12},
    {lang: "Elixir", years: 3},
    {lang: "Docker", years: 7},
    {lang: "Kubernets", years: 4},
    {lang: "Blockchain", years: 2},
    // {lang: "Scientific Python", years: 3},
    {lang: "JavaScript", years: 9},
    {lang: "TypeScript", years: 2},
    {lang: "Airflow", years: 4},
    // {lang: "ReactJS", years: 7},
    // {lang: "D3", years: 3},
    // {lang: "MySQL", years: 4},
    // {lang: "HTML/CSS", years: 5},
    // {lang: "SASS", years: 2}
  ].sort(sortExperience)
}

export function sortExperience(a,b){
  if (a.years<b.years)
      return 1
    else if (a.years==b.years)
      return 0
    return -1
}

export function getCarouselData(){
  return[
    {
      img: "./assets/img/carousel/p1.png",
      title: "Inspect Organs",
      content: "View medical images in 3 different views with multiple modalities (axial, coronal, sagittal and 3D model)"
    },
    {
      img: "./assets/img/carousel/p2.png",
      title: "Easy segmentation”",
      content: "Easily mark brush strokes on the desired structure"
    },
    {
      img: "./assets/img/carousel/p3.png",
      title: "Immediate Result",
      content: "Segment the selected structure in no time"
    },
    {
      img: "./assets/img/carousel/p4.png",
      title: "Export Data",
      content: "Export data to RTStruct format"
    },

    {
      img: "./assets/img/carousel/p5.png",
      title: "Multiple Modalities",
      content: "Apply different colors to different modalities"
    }
  ]
}






// WEBPACK FOOTER //
// ./app/helpers/utils.js